import React, { useState } from "react";
// import { useRouter } from "next/router";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
// import Image from "next/image";
import {
  BsArrowLeftShort,
  BsChevronDown,
  BsPerson,
  BsFillCalendar2PlusFill,
} from "react-icons/bs";
import { MdOutlineCastForEducation, MdAreaChart } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { RiDashboardFill } from "react-icons/ri";
import { AiOutlineLogout, AiOutlineSetting } from "react-icons/ai";

const SideBar = ({ open, setOpen }) => {
  // const router = useRouter();
  const navigate = useNavigate();
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const Menus = [
    {
      title: "DASHBOARD",
      route: "/adminpanel/dashboard/",
      icon: <RiDashboardFill />,
    },
    {
      title: "RESULTS",
      route: "/adminpanel/result/",
      icon: <RiDashboardFill />,
    },
    {
      title: "UNIVERSITIES",
      route: "/adminpanel/universities/",
      icon: <FaUniversity />,
    },
    {
      title: "DISCIPLINES",
      route: "/adminpanel/discipline/",
      icon: <MdOutlineCastForEducation />,
    },
    {
      title: "YEAR OF ADMISSION",
      route: "/adminpanel/admissionyear/",
      icon: <BsFillCalendar2PlusFill />,
    },
    {
      title: "DISTRICTS",
      route: "/adminpanel/domicile/",
      icon: <MdAreaChart />,
    },
    // { title: "Profile", spacing: true, route: "/", icon: <BsPerson /> },
    // { title: "Setting", route: "/", icon: <AiOutlineSetting /> },
    { title: "Logout", route: "/login", icon: <AiOutlineLogout /> },
  ];

  const handleSideBarRouting = (routeName) => {
    // router.push(routeName);

    console.log("routeName");
    console.log(routeName);

    navigate(routeName);
  };

  const handleLogout = () => {
    Swal.fire({
      title: "Logout",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed) {
        // router.push("/login/");
        navigate("/login");
      }
    });
  };

  return (
    <div className="flex fixed">
      <div
        className={`bg-gray-200 h-screen shadow-black shadow-lg p-5 pt-20 ${
          open ? " w-48" : "w-0"
        } duration-300 relative`}
      >
        <BsArrowLeftShort
          className={`bg-white text-dark-purple text-3xl rounded-full absolute -right-3 top-9 border border-dark-purple cursor-pointer ${
            !open && "rotate-180"
          }`}
          onClick={() => setOpen(!open)}
        />

        <div className="flex justify-center">
  <Link to="/adminpanel"> {/* Use Link to navigate to "/adminpanel" */}
    <img
      className="w-32 h-auto"
      src="/logo.png"
      alt="S.E.E.F."
      width="100px" // Provide width as a string with units
      height="100px" // Provide height as a string with units
    />
  </Link>
</div>

        <ul className="pt-8">
          {Menus.map((menu, index) => (
            <li
              key={index}
              className={`text-sm font-bold flex items-center gap-x-4 cursor-pointer p-2 hover:bg-white rounded-md ${
                menu.spacing ? "mt-9" : "mt-2"
              } mt-2`}
              onClick={() =>
                menu.title === "Logout"
                  ? handleLogout()
                  : handleSideBarRouting(menu.route)
              }
            >
              <span
                className={`text-2xl block float-left ${
                  !open && "hidden md:hidden"
                }`}
              >
                {menu.icon}
              </span>
              <span
                className={`text-base font-medium flex-1 duration-300 ${
                  !open && "scale-0"
                }`}
              >
                {menu.title}
              </span>
              {menu.submenu && open && (
                <BsChevronDown
                  className={`${submenuOpen && "rotate-180"}`}
                  onClick={() => setSubmenuOpen(!submenuOpen)}
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
